import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import TouchButton from "../../atoms/TouchButton/TouchButton";
import InputSelect from "../../atoms/InputSelect/InputSelect";
import Male from "../../../assets/Male.svg";
import Female from "../../../assets/Female.svg";
import { QuestionProps } from "../../../types/components/molecules/questionProps";

const Fourth = ({ formData, setFormData, onValidationChange, mode = 'wizard' }: QuestionProps) => {
  const { t } = useTranslation();

  useEffect(() => {
    onValidationChange?.(!!formData.sex);
  }, [formData.sex, onValidationChange]);

  if (mode === 'validation') {
    return (
      <InputSelect
        label={t("animalInfo:PROFIL_VALIDATION.SEX")}
        datas={[
          { value: "male", label: t("animalInfo:QUESTION_FOUR.MALE") },
          { value: "female", label: t("animalInfo:QUESTION_FOUR.FEMALE") },
        ]}
        value={formData.sex ?? ""}
        onChange={(event) => setFormData({ ...formData, sex: event.target.value })}
      />
    );
  }

  return (
    <>
      <TouchButton
        text={t("animalInfo:QUESTION_FOUR.FEMALE")}
        logoPath={Female}
        active={formData.sex === "female"}
        onClick={() => {
          setFormData({ ...formData, sex: "female" });
        }}
      />
      <TouchButton
        text={t("animalInfo:QUESTION_FOUR.MALE")}
        logoPath={Male}
        active={formData.sex === "male"}
        onClick={() => {
          setFormData({ ...formData, sex: "male" });
        }}
      />
    </>
  );
};

export default Fourth;
